import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export enum SupportedLedColors {
  RED = 'rgb(255,0,0)',
  GREEN = 'rgb(0,255,0)',
  BLUE = 'rgb(0,0,255)',
  WHITE = 'rgb(255,255,255)',
  OFF = 'rgb(0,0,0)',
  YELLOW = 'rgb(255,255,0)',
  AZURE = 'rgb(0,255,255)',
  VIOLET = 'rgb(255,0,255)',
}

@Injectable({
  providedIn: 'root',
})
export class LedControlService {
  private httpClient = inject(HttpClient);
  private apiUrl = 'https://localhost/ajax/webApp';

  requestChangeLED(rgb: SupportedLedColors) {
    const body = {
      colorRGB: rgb,
    };

    return this.httpClient.post('https://localhost/ajax/ledControl', body);
  }

  requestChangeLEDViaRGB(rgb: string) {
    const body = {
      colorRGB: rgb,
    };

    return this.httpClient.post('https://localhost/ajax/ledControl', body);
  }

  isUserAgentFromUnit(): boolean {
    const ua = navigator.userAgent || '';
    return ua.toLowerCase().includes('cue');
  }
}
